export default __webpack_public_path__ + "static/media/training-course.c06f9189.svg";